'use strict'

const { combineSubscribers } = require('redux-serial-effects')

const records = require('../records/subscriber')

module.exports = ({ recordStore }) =>
  combineSubscribers({ records: records(recordStore) })



// WEBPACK FOOTER //
// ./dataset-controller/rootSubscriber.js